import React from 'react';

import {
  Modal,
  ModalBody,
  ModalBodyProps,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalFooterProps,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

interface ModalSheetProps {
  isOpen: boolean;
  onClose: () => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;

  bodyProps?: ModalBodyProps;
  footerProps?: ModalFooterProps;
}

const ModalSheet: React.FC<ModalSheetProps> = (props) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} isCentered>
      <ModalOverlay />
      <ModalContent mx={4}>
        {props.header && <ModalHeader>{props.header}</ModalHeader>}

        <ModalBody {...(props.bodyProps ?? {})}>{props.children}</ModalBody>

        <ModalCloseButton
          top={3}
          right={3}
          borderRadius="50%"
          w={6}
          h={6}
          bg="backgroundSecondary"
        />

        {props.footer && (
          <ModalFooter {...(props.footerProps ?? {})}>
            {props.footer}
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export { ModalSheet };
